// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import {jwtDecode} from 'jwt-decode';
// const JWT_SECRET = 'secret';
// const ProtectedRoute = ({ children }) => {

//   const userCookieadmin = Cookies?.get('token');
//   const token = userCookieadmin ? JSON.parse(userCookieadmin) : undefined;
//   if (!token) {
//     return <Navigate to="/auth/login" />;
//   }

//   try {
    
//     const decodedToken = jwtDecode(token);
// console.log(decodedToken);
//     // Check if the token is expired
//     if (decodedToken.exp * 1000 < Date.now()) {
//       Cookies.remove('token');
//       Cookies.remove('user');

//       return <Navigate to="/auth/login" />;
//     }

//     // Additional token validation logic if needed
//   } catch (error) {
//     // Invalid token
//     Cookies.remove('token');
//     return <Navigate to="/auth/login" />;
//   }

//   return children;
// };

// export default ProtectedRoute;



// import React, { useEffect, useState } from 'react';
// import { Navigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import {jwtDecode} from 'jwt-decode';
// import axios from 'axios';

// const JWT_SECRET = 'secret'; // Make sure this matches your backend secret

// // Utility function to check if the user has the required permission
// const checkUserPermission = (userPermissions, method, endpoint) => {
//   return userPermissions.some(permission =>
//     permission.method === method && permission.endpoint === endpoint
//   );
// };

// const ProtectedRoute = ({ children, method, endpoint }) => {
//   const [permissions, setPermissions] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [hasPermission, setHasPermission] = useState(false);

//   useEffect(() => {
//     const fetchPermissions = async () => {
//       const userCookieadmin = Cookies.get('token');
//       const token = userCookieadmin ? JSON.parse(userCookieadmin) : undefined;

//       if (!token) {
//         setIsLoading(false);
//         return <Navigate to="/auth/login" />;
//       }

//       try {
//         const decodedToken = jwtDecode(token);
// console.log(decodedToken,"decodedToken")
//         // Check if the token is expired
//         if (decodedToken.exp * 1000 < Date.now()) {
//           Cookies.remove('token');
//           Cookies.remove('user');
//           setIsLoading(false);
//           return <Navigate to="/auth/login" />;
//         }

//         // Fetch user permissions
//         const response = await axios.get('/api/v1/permissions', {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         });
//         const userPermissions = response.data.data.permissions;
//         setPermissions(userPermissions);

//         // Check if the user has the necessary permissions
//         const permissionCheck = checkUserPermission(userPermissions, method, endpoint);
//         setHasPermission(permissionCheck);
//         setIsLoading(false);
//       } catch (error) {
//         // Invalid token or other error
//         Cookies.remove('token');
//         setIsLoading(false);
//         return <Navigate to="/auth/login" />;
//       }
//     };

//     fetchPermissions();
//   }, [method, endpoint]);

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }

//   if (!hasPermission) {
//     return <Navigate to="/unauthorized" />;
//   }

//   return children;
// };

// export default ProtectedRoute;











import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';
import axios from 'axios';
import { Spinner, Box, Text } from '@chakra-ui/react';
import Api from '../api/ApiUrl';
const checkUserPermission = (permissions, method, endpoint) => {
  console.log(permissions, "permissions",method,endpoint)
  return permissions.some(permission => 
    permission.method === method && permission.endpoint === endpoint
  );
};

const ProtectedRoute = ({ children, method, endpoint }) => {
  const [permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [islogin, setislogin] = useState(true);

  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const fetchPermissions = async () => {
      const userCookieadmin = Cookies.get('token');
      const token = userCookieadmin ? JSON.parse(userCookieadmin) : undefined;

      if (!token) {
        setIsLoading(false);
        setislogin(false);

        // return <Navigate to="/auth/login" />;
      }

      // try {
      //   const decodedToken = jwtDecode(token);
      //   console.log(decodedToken, "decodedToken");

      //   // Check if the token is expired
      //   if (decodedToken.exp * 1000 < Date.now()) {
      //     Cookies.remove('token');
      //     Cookies.remove('user');
      //     setIsLoading(false);
      //     return <Navigate to="/auth/login" />;
      //   }

      //   const userPermissions = decodedToken?.id?.permissions;

      //   console.log(userPermissions)
      //   setPermissions(userPermissions);

      //   // Check if the user has the necessary permissions
      //   const permissionCheck = checkUserPermission(userPermissions, method, endpoint);
      //   setHasPermission(permissionCheck);
      //   setIsLoading(false);
      // } catch (error) {
      //   // Invalid token or other error
      //   Cookies.remove('token');
      //   setIsLoading(false);
      //   return <Navigate to="/auth/login" />;
      // }
    };

    fetchPermissions();
  }, [method, endpoint]);

  // if (isLoading) {
  //   return <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
  //     <Spinner size="xl" />
  //     <Text ml={4}>Loading...</Text>
  //   </Box>;
  // }

  if (!islogin) {
    // return <Navigate to="/unauthorized" />;
    return <Navigate to="/auth/login" />;

  }

  return children;
};

export default ProtectedRoute;
